import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBenefisUIContext } from "../BenefisUIContext";
import { benefisType, initialFilter } from "../BenefisUIHelpers";
import { getBenefisCategoryAll } from "../../../BenefisCategory/_redux/benefisCategory/benefisCategoryCrud";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Select } from "../../../../../_metronic/_partials/controls";

const prepareFilter = (queryParams, values) => {
  const { searchName, benefis_category_uuid, type } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = searchName ?? "";
  filter.benefis_category_uuid = benefis_category_uuid ?? "";
  filter.type = type ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const BenefisFilter = ({ listLoading }) => {
  // Benefis UI Context
  const benefisUIContext = useBenefisUIContext();
  const benefisUIProps = useMemo(() => {
    return {
      setQueryParams: benefisUIContext.setQueryParams,
      queryParams: benefisUIContext.queryParams,
      filterType: benefisUIContext.filterType,
    };
  }, [benefisUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(benefisUIProps.queryParams, values);
    if (!isEqual(newQueryParams, benefisUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      benefisUIProps.setQueryParams(newQueryParams);
    }
  };

  const [options, setoptions] = useState({
    benefis_category: [],
  });

  useEffect(() => {
    getBenefisCategoryAll()
      .then((res) =>
        setoptions((prevState) => ({
          benefis_category: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
  }, []);

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="searchName"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.searchName}
                onChange={(e) => {
                  setFieldValue("searchName", e.target.value);
                  clearTimeout();
                  setTimeout(() => {
                    handleSubmit();
                  }, 500);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Name
              </small>
            </div>
            <div className="col-lg-4">
              <Autocomplete
                name="benefis_category_uuid"
                options={options.benefis_category}
                value={
                  options.benefis_category.length > 0 &&
                  options.benefis_category.find(
                    (item) => item.uuid === values.benefis_category_uuid
                  )
                }
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  if (value) {
                    setFieldValue("benefis_category_uuid", value.uuid);
                    handleSubmit();
                  } else {
                    setFieldValue("benefis_category_uuid", null);
                    handleSubmit();
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Pilih Kategori Benefis"
                    variant="outlined"
                    disableClearable
                    size="small"
                  />
                )}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Kategori Benefis
              </small>
            </div>
            <div className="col-lg-4">
              <select
                className="form-control"
                name="is_active"
                label="Status Aktif"
                onChange={(e) => {
                  setFieldValue("type", e.target.value);
                  handleSubmit();
                }}
              >
                <option value={""}>PILIH</option>
                {benefisType.map((row) => (
                  <option key={row.value} value={row.value}>
                    {row.name}
                  </option>
                ))}
              </select>
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Tipe
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
